// class UserInputStore {
//   constructor() {
//     /**
//      * @type {Userdata}
//      */
//     this.userInput = [];
//   }

//   setUserInput(userInput) {
//     this.userInput = userInput;
//   }

//   getUserInput() {
//     return this.userInput;
//   }
// }


import { UserInputStoreInstance as UserInputStore } from "shared-library";
/**
 * @type {Userdata}
 */
export default UserInputStore;
